export default __webpack_public_path__ + "static/media/home6.914a1d0b.png";